import { FirebaseOptions } from 'firebase/app'
export const SITE_URL = 'https://miyauchi.dev/'
export const SITE_NAME = 'miyauci.me'

export const MOBILE_BREAK_POINT = 768

export const firebaseOptions: FirebaseOptions = {
  apiKey: 'AIzaSyAN_gLPDQgXzROBhfpoEq7g-Wek6FY1kJE',
  authDomain: 'blorogue.firebaseapp.com',
  projectId: 'blorogue',
  storageBucket: 'blorogue.appspot.com',
  messagingSenderId: '205944386882',
  appId: '1:205944386882:web:f48733fc94e54f0de244db',
  measurementId: 'G-DWBGDDWNR9'
}

export const CHATROOM_TYPES = ['job', 'public']
